import { combineReducers } from "redux";
import flashMessageReducer from "./flashMessageReducer";

const rootReducer = combineReducers({
  user: (state = {}, action) => state,
  session: flashMessageReducer,
});

export default rootReducer;
